import React from 'react';

interface Props {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

const ChainIcon = ({
  className,
  width = 24,
  height = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9233 9.02665C12.5565 9.02805 11.3587 9.94134 10.9961 11.2586C10.89 11.719 10.4879 12.0507 10.0157 12.0676C9.70206 12.0671 9.40624 11.922 9.21389 11.6745C9.02153 11.4269 8.95414 11.1045 9.03123 10.8006C9.60496 8.56588 11.6192 7.0026 13.9273 7.00065H15.7281C18.4185 6.95859 20.6971 8.97422 20.9824 11.6486C21.1863 14.0984 19.601 16.3408 17.2228 16.9666C16.9175 17.0468 16.5923 16.9812 16.3421 16.7888C16.0919 16.5965 15.945 16.2991 15.9442 15.9836V15.9376C15.9552 15.4881 16.2714 15.104 16.7105 15.0066C18.2695 14.5945 19.2373 13.0397 18.9185 11.4596C18.5954 10.0174 17.3025 9.00089 15.8242 9.02665H13.9233ZM10.0745 14.9735C11.4388 14.9687 12.6325 14.0551 12.9935 12.7395C13.101 12.2775 13.5064 11.946 13.9805 11.9325C14.294 11.933 14.5897 12.0781 14.782 12.3257C14.9742 12.5732 15.0416 12.8956 14.9645 13.1995C14.3911 15.4342 12.3777 16.9975 10.0705 16.9995H8.27054C5.5809 17.0421 3.30275 15.0263 3.01754 12.3515C2.81416 9.90185 4.3986 7.65969 6.77554 7.03347C7.08067 6.95329 7.40573 7.01895 7.65581 7.2113C7.90588 7.40365 8.05275 7.70098 8.05354 8.01647V8.06247C8.04259 8.512 7.72654 8.89614 7.28754 8.99348C5.72926 9.40563 4.76184 10.9604 5.08054 12.5405C5.4036 13.9831 6.69643 14.9997 8.17454 14.9735H10.0745Z"
      fill={color}
    />
  </svg>
);

export default ChainIcon;
